"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnorderedListIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000' : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("path", { d: "M20.3002 8.6001L11.5 8.6001", stroke: fill, strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M20.3002 13.8003L11.5 13.8003", stroke: fill, strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M20.3002 19L11.5 19", stroke: fill, strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("ellipse", { cx: "8.1", cy: "18.9999", rx: "0.6", ry: "0.6", fill: fill }, void 0),
            jsx_runtime_1.jsx("ellipse", { cx: "8.1", cy: "13.8002", rx: "0.6", ry: "0.6", fill: fill }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "8.1", cy: "8.6", r: "0.6", fill: fill }, void 0)] }, void 0));
};
exports.UnorderedListIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 28 28' });
//# sourceMappingURL=UnorderedListIcon.js.map